import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CreateClaimTabInfo } from '../../../interfaces/create-claim-tab-info'
import { ClaimInformation } from 'app/interfaces/claim-information'
import { FormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { NgIf } from '@angular/common'

@Component({
    selector: 'app-claim-info',
    standalone: true,
    imports: [FormsModule, TranslateModule, NgIf],
    templateUrl: './claim-info.component.html',
    styleUrl: './claim-info.component.scss',
})
export class ClaimInfoComponent implements OnInit {
    @Input() claimInformation!: ClaimInformation
    @Output() tabInit = new EventEmitter<CreateClaimTabInfo>()
    @Output() updateClaim = new EventEmitter<ClaimInformation>()
    @Output() onContinueState = new EventEmitter<boolean>()
    readonly MIN_DESCRIPTION_LENGTH = 50
    readonly MIN_SUBJECT_LENGTH = 10
    readonly MAX_SUBJECT_LENGTH = 250

    descriptionIncomplete = false
    subjectInvalid = false
    private subjectTimer: any = null
    private descriptionTimer: any = null

    ngOnInit() {
        this.tabInit.emit({
            currentTab: 'claim-info',
            previousTab: null,
            nextTab: 'material-selection',
        })
        this.claimInformation.lastModifiedTab = 'claim-info'

        this.onContinueState.emit(this.canContinue())

        if (this.claimInformation?.claimInfo?.description) this.checkDescription()
        if (this.claimInformation?.claimInfo?.subject) this.checkSubject()
    }

    onClaimInfoChange() {
        this.updateClaim.emit(this.claimInformation)
        this.onContinueState.emit(this.canContinue())
    }

    onSubjectChange() {
        this.subjectInvalid = false
        this.onClaimInfoChange()
        if (this.subjectTimer) clearTimeout(this.subjectTimer)
        this.subjectTimer = setTimeout(() => this.checkSubject(), 800)
    }

    onDescriptionChange() {
        this.descriptionIncomplete = false
        this.onClaimInfoChange()
        if (this.descriptionTimer) clearTimeout(this.descriptionTimer)
        this.descriptionTimer = setTimeout(() => this.checkDescription(), 800)
    }

    canContinue(): boolean {
        const { claimInfo } = this.claimInformation
        return !!(claimInfo?.subject && claimInfo?.description &&
            claimInfo?.subject.length >= this.MIN_SUBJECT_LENGTH &&
            claimInfo?.subject.length <= this.MAX_SUBJECT_LENGTH &&
            claimInfo?.description.length >= this.MIN_DESCRIPTION_LENGTH)
    }

    checkSubject() {
        const { claimInfo } = this.claimInformation
        if (!claimInfo?.subject) {
            this.subjectInvalid = false
            return
        }
        this.subjectInvalid = claimInfo.subject.length < this.MIN_SUBJECT_LENGTH ||
            claimInfo.subject.length > this.MAX_SUBJECT_LENGTH
    }

    checkDescription() {
        const { claimInfo } = this.claimInformation
        if (!claimInfo?.description) {
            this.descriptionIncomplete = false
            return
        }
        this.descriptionIncomplete = claimInfo.description.length < this.MIN_DESCRIPTION_LENGTH
    }
}
